// extracted by mini-css-extract-plugin
export default {"dividerRow":"TableBody_dividerRow__htbsV","divider":"TableBody_divider__5-CGy","openCaret":"TableBody_openCaret__l7I8P","loadingCell":"TableBody_loadingCell__B9YaU"};